const WinlosesTypes = {
    FETCH_START:    '[ONNA] FETCH START',
    FETCH_SUCCESS:  '[ONNA] FETCH SUCCESS',
    FETCH_FAILURE:  '[ONNA] FETCH FAILURE'
};

export default WinlosesTypes;